import { Form } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { MODAL_BUTTON_WIDTH } from '@/features/social-button'
import { GooglePairButton } from '@/features/social-button/google/pair'
import { YahooPairButton } from '@/features/social-button/yahoo/pair'
import { isPlatformEnabled } from '@/shared/config'
import { useI18n } from '@/shared/lib/i18n'
import { Button, ButtonPlainBack, Divider, Modal, type ModalProps } from '@/shared/ui'
import { Input } from '@/shared/ui/input-v2/view'

type LinkYourEmailDialogProps = ModalProps & {
    onFormSubmit: (data: FormData) => void
    formErrorMessage: string
    onLaterButtonClick: () => void
    defaultFormValues?: { email: string }
    submitButtonDisabled: boolean
}

export function LinkYourEmailDialog({
    onClose,
    onLaterButtonClick,
    submitButtonDisabled,
    formErrorMessage,
    defaultFormValues,
    onFormSubmit,
    ...modalProps
}: LinkYourEmailDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...modalProps} styles={css.raw({ width: '[27.5rem]' })}>
            <Modal.Header styles={css.raw({ backgroundColor: 'info' })} icon="fa-solid fa-feather-pointed">
                {i18n.NEWSLETTER__POPUP_ADD_EMAIL_TITLE}
            </Modal.Header>
            <Modal.Body>
                <span
                    dangerouslySetInnerHTML={{
                        __html: i18n.NEWSLETTER__POPUP_ADD_EMAIL_DESCR,
                    }}
                />
            </Modal.Body>
            <div
                className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2',
                    paddingX: '4',
                    paddingY: '2',
                })}
            >
                <GooglePairButton.View state="link-your-email-dialog" width={MODAL_BUTTON_WIDTH} height="42px" />
                {isPlatformEnabled('yahoo') && <YahooPairButton styles={css.raw({ height: '[42px]' })} />}
            </div>
            <Divider styles={css.raw({ px: '4' })}>{i18n.TEXT_OR}</Divider>
            <Form
                method="post"
                onSubmit={(e) => {
                    e.preventDefault()
                    onFormSubmit(new FormData(e.currentTarget))
                }}
                className={css({ paddingX: '4', paddingTop: '2' })}
            >
                <Input
                    type="email"
                    name="email"
                    placeholder={i18n.USER_EMAIL}
                    autoComplete="on"
                    isError={Boolean(formErrorMessage)}
                    description={formErrorMessage ?? null}
                    required
                    autoFocus
                    defaultValue={defaultFormValues?.email}
                    data-testid="email-input"
                    isDisabled={submitButtonDisabled}
                    startDecorator={
                        <div
                            className={css({
                                width: '[2.375rem]',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            })}
                        >
                            <i className={cx('fa-solid fa-envelope', css({ fontSize: 'md' }))} />
                        </div>
                    }
                />
                <Modal.Buttons
                    styles={css.raw({ flexDirection: 'column', gap: '1', paddingX: '0', pb: '2', paddingTop: '5' })}
                >
                    <Button type="submit" color="info" isDisabled={submitButtonDisabled}>
                        {i18n.EMAIL_BIND__BTN_ADD}
                    </Button>
                    <ButtonPlainBack onPress={onLaterButtonClick} />
                </Modal.Buttons>
            </Form>
        </Modal>
    )
}
